import React, { useState, useEffect } from "react";
import axios from "axios";
import { Language, Country, TranslationFormData } from "../types";
import SearchableDropdown from "./SearchableDropdown";
import { useNavigate } from "react-router-dom";

function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  return String(error);
}

interface TranslationFormProps {
  // onSubmit: (formData: TranslationFormData) => void;
  // isLoading: boolean;
}

//{ onSubmit, isLoading }
//function PDFUpload() {
const PDFUpload: React.FC<TranslationFormProps> = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);

  const [languages, setLanguages] = useState<Language[]>([]);
  const [countries, setCountries] = useState<Country[]>([]);
  const [formData, setFormData] = useState<TranslationFormData>({
    sourceLanguage: "",
    targetLanguage: "",
    sourceCulture: "",
    targetCulture: "",
    book: null,
  });
  const [isFormValid, setIsFormValid] = useState(false);

  // Fetch languages and countries on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("hello");
        const [languagesRes, countriesRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/api/languages`),
          axios.get(`${process.env.REACT_APP_API_URL}/api/countries`),
        ]);
        setLanguages(languagesRes.data);
        setCountries(countriesRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Update form validity whenever form data changes
  useEffect(() => {
    const {
      sourceLanguage,
      targetLanguage,
      sourceCulture,
      targetCulture,
      book,
    } = formData;
    setIsFormValid(
      !!sourceLanguage &&
        !!targetLanguage &&
        !!sourceCulture &&
        !!targetCulture &&
        !!book
    );
  }, [formData]);

  // const handleChange = (e: any) => {
  //   if (e.target.files[0]) {
  //     setFile(e.target.files[0]);
  //   }
  // };

  const handleInputChange = (
    field: keyof TranslationFormData,
    value: string
  ) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFileSelected = (e: any) => {
    if (e.target.files[0]) {
      setFormData((prev) => ({
        ...prev,
        book: e.target.files[0],
      }));
      setFile(e.target.files[0]);
    }
    // setFormData((prev) => ({
    //   ...prev,
    //   book: file,
    // }));
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first.");
      return;
    }

    const form = new FormData();
    const userId = localStorage.getItem("userId");
    form.append("file", formData.book!); // non-null assertion
    form.append("sourceLanguage", formData.sourceLanguage);
    form.append("targetLanguage", formData.targetLanguage);
    form.append("sourceCulture", formData.sourceCulture);
    form.append("targetCulture", formData.targetCulture);
    form.append("userId", userId!);

    // const formData = new FormData();
    // formData.append("file", file);

    try {
      // console.log(formData);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/upload-pdf/`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert(res.data.message);
      navigate("/translate", { state: res.data.id });
    } catch (error) {
      alert({ message: getErrorMessage(error) });
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #81E6D9, #3182CE)",
        color: "#fff",
        fontFamily: "'Arial', sans-serif",
      }}
    >
      <h2 style={{ fontSize: "2.5rem", marginBottom: "2rem" }}>Upload a PDF</h2>

      <input
        type="file"
        accept="application/pdf"
        onChange={(e) => handleFileSelected(e)}
        style={{
          fontSize: "1.2rem",
          padding: "0.5rem 1rem",
          marginBottom: "2rem",
          borderRadius: "8px",
          border: "1px solid #fff",
          outline: "none",
          width: "80%",
          maxWidth: "500px",
        }}
      />

      <div style={{ width: "80%", maxWidth: "600px", marginBottom: "2rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1.5rem",
          }}
        >
          <SearchableDropdown
            options={languages}
            label="Source Language"
            id="sourceLanguage"
            value={formData.sourceLanguage}
            onChange={(value) => handleInputChange("sourceLanguage", value)}
          />

          <SearchableDropdown
            options={languages}
            label="Target Language"
            id="targetLanguage"
            value={formData.targetLanguage}
            onChange={(value) => handleInputChange("targetLanguage", value)}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <SearchableDropdown
            options={countries}
            label="Source Culture"
            id="sourceCulture"
            value={formData.sourceCulture}
            onChange={(value) => handleInputChange("sourceCulture", value)}
          />

          <SearchableDropdown
            options={countries}
            label="Target Culture"
            id="targetCulture"
            value={formData.targetCulture}
            onChange={(value) => handleInputChange("targetCulture", value)}
          />
        </div>
      </div>

      <button
        onClick={handleUpload}
        style={{
          padding: "0.8rem",
          fontSize: "1rem",
          fontWeight: "bold",
          background: "#2D3748",
          color: "#fff",
          border: "1px solid #ccc",
          borderRadius: "12px",
          cursor: "pointer",
          transition: "background 0.3s ease",
        }}
        onMouseOver={(e) => (e.currentTarget.style.background = "#1A202C")}
        onMouseOut={(e) => (e.currentTarget.style.background = "#2D3748")}
      >
        Start Editing!
      </button>
    </div>
  );
};

export default PDFUpload;
